<div class="row my-3 p-4">
	<div class="col pt-2">
		<div
			id="z-index-0"
			class="vh-85"
			leaflet
			[leafletOptions]="options"
			(leafletMapReady)="onMapReady($event)"
		>
			<div
				style="z-index: 99999; position: relative"
				class="d-flex justify-content-end"
			>
				<div class="d-flex flex-column m-2">
					<div
						class="d-flex p-0 flex-column my-2 text-center bg-white rounded-pill"
					>
						<span
							class="hand-cursor mb-0 text-center border-bottom border-dark"
							(click)="onClickZoomIn()"
							><i
								class="bi bi-plus fs-5 theme-main-color"
								aria-hidden="true"
							></i
						></span>
						<span
							class="hand-cursor mt-0 text-center"
							(click)="onClickZoomOut()"
							><i class="bi bi-dash fs-5" aria-hidden="true"></i
						></span>
					</div>

					<span
						class="hand-cursor my-2 px-2 text-center bg-white rounded-pill"
						(click)="onClickCenter()"
						><i
							class="bi bi-geo-alt-fill fs-5 theme-main-color"
							aria-hidden="true"
						></i
					></span>
				</div>
			</div>
		</div>
	</div>
</div>
